<div>
  <form class="form-vertical">
    <div class="row">

      <!-- value groups -->
      <div ng-repeat="group in vm.labconfig.groups">
        <div class="form-group col-md-4">
          <label>
            <input type="checkbox"
                   ng-model="vm.ginclude[$index]"
                   tabindex="0"
                   ng-checked="vm.ginclude[$index]"
                   ng-init="vm.ginclude[$index] = false"
                   ng-click="vm.toggleGroup()"/> {{group.name}}</label>
        </div>
      </div>
    </div>

    <!-- add additional values -->
    <label for="addlabval">Zusätzliche Laborwerte</label>
    <tags-input ng-model="vm.additionalvalues"
                ng-init="vm.additionalvalues = []"
                tabindex="0"
                display-property="name" id="addlabval"
                add-on-comma="false"
                min-length="1"
                placeholder="Tippen zum Vervollständigen"
                replace-spaces-with-dashes="false"
                on-tag-added="vm.joinValues()"
                on-tag-removed="vm.joinValues()"
                template="tag-template">
      <auto-complete source="vm.loadValues($query)"
                     min-length="1"
                     load-on-focus="false"
                     load-on-down-arrow="true"
                     load-on-empty="true"
                     max-results-to-show="32"
                     template="autocomplete-template"></auto-complete>
    </tags-input>

    <!-- selected values -->
    <h4>Ausgewählte Laborwerte</h4>

<!--    <div class="alert alert-info">
      <span ng-show="vm.allvalues.length > 0" ng-repeat="val in vm.allvalues">{{val}}{{$last ? '' : ', '}} </span>
      <span ng-hide="vm.allvalues.length > 0">Keine Werte ausgewählt</span>
    </div>-->

    <div class="form-group">
      <label for="addlabval">Ausgewählte Laborwerte (Gruppen und Einzelwerte)</label>
      <tags-input ng-model="vm.filtered"
                  tabindex="0"
                  useStrings="true"
                  id="dellabval"
                  min-length="1"
                  placeholder="Unerwünschte Laborwerte löschen"
                  replace-spaces-with-dashes="false"
                  on-tag-removed="vm.deleteLabVal($tag)"
                  template="tag-template">
        <auto-complete source="vm.loadValues($query)"
                       min-length="1"
                       load-on-focus="false"
                       load-on-down-arrow="true"
                       load-on-empty="true"
                       max-results-to-show="32"
                       template="autocomplete-template"></auto-complete>
      </tags-input>
    </div>
    <div class="form-group">
      <label for="addlabval">Ausgeschlossene Laborwerte</label>
      <tags-input ng-model="vm.deleteList"
                  tabindex="0"
                  useStrings="true"
                  id="undellabval"
                  min-length="1"
                  placeholder=""
                  replace-spaces-with-dashes="false"
                  on-tag-removed="vm.undeleteLabVal($tag)"
                  template="tag-template">
        <auto-complete source="vm.loadValues($query)"
                       min-length="1"
                       load-on-focus="false"
                       load-on-down-arrow="true"
                       load-on-empty="true"
                       max-results-to-show="32"
                       template="autocomplete-template"></auto-complete>
      </tags-input>
    </div>
  </form>
  <script type="text/ng-template" id="tag-template">
    <div class="tag-template">
      <div class="right-panel">
        <span>{{$getDisplayText()}}</span>
        <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
      </div>
    </div>
  </script>


  <script type="text/ng-template" id="autocomplete-template">
    <div class="autocomplete-template">
      <div>
        <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>
      </div>
    </div>
  </script>
</div>
